export const services = [
  {
    id: 'hydraulics',
    title: 'Hydraulics',
    summary: 'Repair and rebuilding support for industrial hydraulic cylinders and systems.',
    path: '/services/hydraulics',
    image: '/images/landing-img1.png',
    icon: '/icons/hydraulic-cylinder.svg',
  },
  {
    id: 'gearboxes',
    title: 'Gearboxes',
    summary: 'Industrial gearbox repair support for production and heavy-use equipment.',
    path: '/services/gearboxes',
    image: '/images/landing-img2.png',
    icon: '/icons/gearbox.svg',
  },
  {
    id: 'industrial-repair',
    title: 'Industrial Repair',
    summary: 'Mechanical repair support with a focus on gearboxes and hydraulics.',
    path: '/services/industrial-repair',
    image: '/images/landing-img3.png',
    icon: '/icons/industrial-repair.svg',
  },
];
